import { AvFeedback, AvForm, AvGroup, AvField, AvInput, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import React, { Component, Fragment } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import { libphonenumber } from 'react-intl-tel-input/dist/libphonenumber.js';
import 'react-intl-tel-input/dist/main.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Col, Label, Row, CustomInput } from 'reactstrap';
import request, { NodeURL } from '../../api/api';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './profile.scss';
import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import SignaturePad from 'react-signature-canvas';
import logo from '../../images/candidate/agency-logo.jpg';
import titleImage from '../../images/Referance/title_icon.svg';
const style_in = { cursor: 'pointer' };

class Registration extends Component {
   state = {
      remployeeyes: false,
      signature: '',
      showModal: false,
      refereephone: {
         number: '',
         code: '',
         dialcountry: 'gb',
      },
      applicantphone: {
         number: '',
         code: '',
         dialcountry: 'gb',
      },
      phoneerror: false,
      phoneerror1: false,
      employedfrom: null,
      employedto: null,
      id_checker: false,
      logourl: '',
      company_name: '',
      refereefirstname: '',
      applicantfirstname: '',
      applicantlastname: '',
      refereelastname: '',
      refereeemail: '',
      logo_loder: false,
      link_expired_show: false,
      employedfrom_err: false,
      employedto_err: false,
      characterRef: 'No',
      avatar: '',
      name : '',
      surname : '',
   };

   componentDidMount() {
      const subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
      this.setState({ logo_loder: true });
      request({
         url: '/site/agencies',
         method: 'POST',
      })
         .then((res) => {
            const filteredlist =
               res && res.response && res.response.result && res.response.result.filter((list) => list.domain.toString() === subdomain.toString());
            this.setState(
               {
                  logourl: filteredlist && filteredlist[0] && filteredlist[0].company_logo,
                  company_name: filteredlist && filteredlist[0] && filteredlist[0].company_name,
               },
               () => {
                  this.setState({ logo_loder: false });
               },
            );
         })
         .catch((err) => {
            this.setState({ logo_loder: false });
         });
      request({
         url: '/site/employee/check.idchecker',
         method: 'POST',
         data: {
            reference_id: this.props && this.props.match && this.props.match.params && this.props.match.params.username ? this.props.match.params.username : '',
         },
      })
         .then((res) => {
            if (res && +res.status === 1) {
               if (String(window.location.href).includes('reference1')) {
                  if (
                     res &&
                     res.response &&
                     res.response.onlineform &&
                     res.response.onlineform.reference1 &&
                     res.response.onlineform.reference1.referee &&
                     res.response.onlineform.reference1.referee.status &&
                     +res.response.onlineform.reference1.referee.status === 2
                  ) {
                     this.setState({ link_expired_show: true });
                  }
                  this.setState({
                     refereefirstname:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference1 &&
                        res.response.onlineform.reference1.firstreffirstname &&
                        res.response.onlineform.reference1.firstreffirstname.length > 0 &&
                        String(res.response.onlineform.reference1.firstreffirstname) !== String(undefined)
                           ? res.response.onlineform.reference1.firstreffirstname
                           : '',
                     applicantfirstname:
                        res && res.response && res.response.name && res.response.name.length > 0 && String(res.response.name) !== String(undefined)
                           ? res.response.name
                           : '',
                     refereelastname:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference1 &&
                        res.response.onlineform.reference1.firstreflastname &&
                        res.response.onlineform.reference1.firstreflastname.length > 0 &&
                        String(res.response.onlineform.reference1.firstreflastname) !== String(undefined)
                           ? res.response.onlineform.reference1.firstreflastname
                           : '',
                     applicantlastname:
                        res && res.response && res.response.surname && res.response.surname.length > 0 && String(res.response.surname) !== String(undefined)
                           ? res.response.surname
                           : '',
                     refereeemail:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference1 &&
                        res.response.onlineform.reference1.firstrefemail &&
                        res.response.onlineform.reference1.firstrefemail.length > 0 &&
                        String(res.response.onlineform.reference1.firstrefemail) !== String(undefined)
                           ? res.response.onlineform.reference1.firstrefemail
                           : '',
                     refereephone: {
                        number:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference1 &&
                           res.response.onlineform.reference1.firstrefphone &&
                           res.response.onlineform.reference1.firstrefphone.number &&
                           res.response.onlineform.reference1.firstrefphone.number.length > 0 &&
                           String(res.response.onlineform.reference1.firstrefphone.number) !== String(undefined)
                              ? res.response.onlineform.reference1.firstrefphone.number
                              : '',
                        code:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference1 &&
                           res.response.onlineform.reference1.firstrefphone &&
                           res.response.onlineform.reference1.firstrefphone.code &&
                           res.response.onlineform.reference1.firstrefphone.code.length > 0 &&
                           String(res.response.onlineform.reference1.firstrefphone.code) !== String(undefined)
                              ? res.response.onlineform.reference1.firstrefphone.code
                              : '',
                        dialcountry:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference1 &&
                           res.response.onlineform.reference1.firstrefphone &&
                           res.response.onlineform.reference1.firstrefphone.dialcountry &&
                           res.response.onlineform.reference1.firstrefphone.dialcountry.length > 0 &&
                           String(res.response.onlineform.reference1.firstrefphone.dialcountry) !== String(undefined)
                              ? res.response.onlineform.reference1.firstrefphone.dialcountry
                              : 'gb',
                     },
                  });
               }
               if (String(window.location.href).includes('reference2')) {
                  if (
                     res &&
                     res.response &&
                     res.response.onlineform &&
                     res.response.onlineform.reference2 &&
                     res.response.onlineform.reference2.referee &&
                     res.response.onlineform.reference2.referee.status &&
                     +res.response.onlineform.reference2.referee.status === 2
                  ) {
                     this.setState({ link_expired_show: true });
                  }
                  this.setState({
                     refereefirstname:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference2 &&
                        res.response.onlineform.reference2.secondreffirstname &&
                        res.response.onlineform.reference2.secondreffirstname.length > 0 &&
                        String(res.response.onlineform.reference2.secondreffirstname) !== String(undefined)
                           ? res.response.onlineform.reference2.secondreffirstname
                           : '',
                     applicantfirstname:
                        res && res.response && res.response.name && res.response.name.length > 0 && String(res.response.name) !== String(undefined)
                           ? res.response.name
                           : '',
                     refereelastname:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference2 &&
                        res.response.onlineform.reference2.secondreflastname &&
                        res.response.onlineform.reference2.secondreflastname.length > 0 &&
                        String(res.response.onlineform.reference2.secondreflastname) !== String(undefined)
                           ? res.response.onlineform.reference2.secondreflastname
                           : '',
                     applicantlastname:
                        res && res.response && res.response.surname && res.response.surname.length > 0 && String(res.response.surname) !== String(undefined)
                           ? res.response.surname
                           : '',
                     refereeemail:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference2 &&
                        res.response.onlineform.reference2.secondrefemail &&
                        res.response.onlineform.reference2.secondrefemail.length > 0 &&
                        String(res.response.onlineform.reference2.secondrefemail) !== String(undefined)
                           ? res.response.onlineform.reference2.secondrefemail
                           : '',
                     refereephone: {
                        number:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference2 &&
                           res.response.onlineform.reference2.secondrefphone &&
                           res.response.onlineform.reference2.secondrefphone.number &&
                           res.response.onlineform.reference2.secondrefphone.number.length > 0 &&
                           String(res.response.onlineform.reference2.secondrefphone.number) !== String(undefined)
                              ? res.response.onlineform.reference2.secondrefphone.number
                              : '',
                        code:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference2 &&
                           res.response.onlineform.reference2.secondrefphone &&
                           res.response.onlineform.reference2.secondrefphone.code &&
                           res.response.onlineform.reference2.secondrefphone.code.length > 0 &&
                           String(res.response.onlineform.reference2.secondrefphone.code) !== String(undefined)
                              ? res.response.onlineform.reference2.secondrefphone.code
                              : '',
                        dialcountry:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference2 &&
                           res.response.onlineform.reference2.secondrefphone &&
                           res.response.onlineform.reference2.secondrefphone.dialcountry &&
                           res.response.onlineform.reference2.secondrefphone.dialcountry.length > 0 &&
                           String(res.response.onlineform.reference2.secondrefphone.dialcountry) !== String(undefined)
                              ? res.response.onlineform.reference2.secondrefphone.dialcountry
                              : 'gb',
                     },
                  });
               }
               if (String(window.location.href).includes('reference3')) {
                  if (
                     res &&
                     res.response &&
                     res.response.onlineform &&
                     res.response.onlineform.reference3 &&
                     res.response.onlineform.reference3.referee &&
                     res.response.onlineform.reference3.referee.status &&
                     +res.response.onlineform.reference3.referee.status === 2
                  ) {
                     this.setState({ link_expired_show: true });
                  }
                  this.setState({
                     refereefirstname:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference3 &&
                        res.response.onlineform.reference3.thirdreffirstname &&
                        res.response.onlineform.reference3.thirdreffirstname.length > 0 &&
                        String(res.response.onlineform.reference3.thirdreffirstname) !== String(undefined)
                           ? res.response.onlineform.reference3.thirdreffirstname
                           : '',
                     applicantfirstname:
                        res && res.response && res.response.name && res.response.name.length > 0 && String(res.response.name) !== String(undefined)
                           ? res.response.name
                           : '',
                     refereelastname:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference3 &&
                        res.response.onlineform.reference3.thirdreflastname &&
                        res.response.onlineform.reference3.thirdreflastname.length > 0 &&
                        String(res.response.onlineform.reference3.thirdreflastname) !== String(undefined)
                           ? res.response.onlineform.reference3.thirdreflastname
                           : '',
                     applicantlastname:
                        res && res.response && res.response.surname && res.response.surname.length > 0 && String(res.response.surname) !== String(undefined)
                           ? res.response.surname
                           : '',
                     refereeemail:
                        res &&
                        res.response &&
                        res.response.onlineform &&
                        res.response.onlineform.reference3 &&
                        res.response.onlineform.reference3.thirdrefemail &&
                        res.response.onlineform.reference3.thirdrefemail.length > 0 &&
                        String(res.response.onlineform.reference3.thirdrefemail) !== String(undefined)
                           ? res.response.onlineform.reference3.thirdrefemail
                           : '',
                     refereephone: {
                        number:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference3 &&
                           res.response.onlineform.reference3.thirdrefphone &&
                           res.response.onlineform.reference3.thirdrefphone.number &&
                           res.response.onlineform.reference3.thirdrefphone.number.length > 0 &&
                           String(res.response.onlineform.reference3.thirdrefphone.number) !== String(undefined)
                              ? res.response.onlineform.reference3.thirdrefphone.number
                              : '',
                        code:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference3 &&
                           res.response.onlineform.reference3.thirdrefphone &&
                           res.response.onlineform.reference3.thirdrefphone.code &&
                           res.response.onlineform.reference3.thirdrefphone.code.length > 0 &&
                           String(res.response.onlineform.reference3.thirdrefphone.code) !== String(undefined)
                              ? res.response.onlineform.reference3.thirdrefphone.code
                              : '',
                        dialcountry:
                           res &&
                           res.response &&
                           res.response.onlineform &&
                           res.response.onlineform.reference3 &&
                           res.response.onlineform.reference3.thirdrefphone &&
                           res.response.onlineform.reference3.thirdrefphone.dialcountry &&
                           res.response.onlineform.reference3.thirdrefphone.dialcountry.length > 0 &&
                           String(res.response.onlineform.reference3.thirdrefphone.dialcountry) !== String(undefined)
                              ? res.response.onlineform.reference3.thirdrefphone.dialcountry
                              : 'gb',
                     },
                  });
               }
               this.setState({ avatar: res && res.response && res.response.avatar ? res.response.avatar : '' });
               this.setState({ name: res && res.response && res.response.name ? res.response.name : '' });
               this.setState({ surname: res && res.response && res.response.surname ? res.response.surname : '' });
            } else {
               this.setState({ link_expired_show: true }, () => {
                  this.setState({ logo_loder: false });
               });
            }
         })
         .catch((err) => {
            console.log('err in /site/employee/check.idchecker', err);
         });
   }
   onChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
   };

   handleChange = (date) => {
      this.setState({ employedfrom: date });
   };

   handleChange_to = (date) => {
      this.setState({ employedto: date });
   };

   openModal = (e) => {
      e.preventDefault();
      this.setState({ showModal: true });
   };

   toggleModal = () => {
      this.setState({ showModal: !this.state.showModal });
   };

   remployeeyes = (yes) => {
      if (yes === 'no') {
         this.setState({
            remployeeyes: true,
            remployee: 'no',
         });
      } else {
         this.setState({
            remployeeyes: false,
            remployee: 'yes',
         });
      }
   };
   charRef = (val) => {
      if (val === 'Yes') {
         this.setState({
            characterRef: 'Yes',
         });
      } else if (val === 'No') {
         this.setState({
            characterRef: 'No',
         });
      }
   };
   disciplinaryactionyes = (yes) => {
      if (yes === 'yes') {
         this.setState({
            disciplinaryactionyes: true,
            disciplinaryaction: 'yes',
         });
      } else {
         this.setState({
            disciplinaryactionyes: false,
            disciplinaryaction: 'no',
         });
      }
   };
   investigationsyes = (yes) => {
      if (yes === 'yes') {
         this.setState({
            investigationsyes: true,
            investigations: 'yes',
         });
      } else {
         this.setState({
            investigationsyes: false,
            investigations: 'no',
         });
      }
   };
   vulnerablepeopleyes = (yes) => {
      if (yes === 'yes') {
         this.setState({
            vulnerablepeopleyes: true,
            vulnerablepeople: 'yes',
         });
      } else {
         this.setState({
            vulnerablepeopleyes: false,
            vulnerablepeople: 'no',
         });
      }
   };
   criminaloffenceyes = (yes) => {
      if (yes === 'yes') {
         this.setState({
            criminaloffenceyes: true,
            criminaloffence: 'yes',
         });
      } else {
         this.setState({
            criminaloffenceyes: false,
            criminaloffence: 'no',
         });
      }
   };
   fileChangedHandler = (evt) => {
      if (evt) {
         const file_data = evt.target.files[0];
         if (file_data.size < 5242880) {
            this.setState({
               campanystamp: file_data,
               campanystampfile: URL.createObjectURL(file_data),
               campanystampName: file_data.name,
            });
         } else {
            toast.error('Maximum upload size is 5MB');
         }
      }
   };
   OnFormSubmit = (event, errors, values) => {
      if (this.state.employedfrom === null) {
         this.setState({ employedfrom_err: true });
      }
      if (this.state.employedto === null) {
         this.setState({ employedto_err: true });
      }
      if (errors && errors.length === 0) {
         // if (this.state.campanystamp) {
         if (this.state.characterRef === 'No') {
            if (this.state.employedfrom === null) {
               this.setState({ employedfrom_err: true });
               return toast.error('Please fill Date Employed from');
            }
            if (this.state.employedto === null) {
               this.setState({ employedto_err: true });
               return toast.error('Please fill Date Employed to');
            }
         }
         if (this.state.signature === '') return toast.error('Please Add Signature');
         let toastId = 'referee_form_front_site_01';
         toastId = toast.info('Please Wait......', { autoClose: false });
         const data = new FormData();
         data.append('signature', this.state.signature);
         data.append(
            'refereefirstname',
            this.state.refereefirstname && this.state.refereefirstname.length > 0 && String(this.state.refereefirstname) !== String(undefined)
               ? this.state.refereefirstname
               : values.refereefirstname,
         );
         data.append(
            'refereelastname',
            this.state.refereelastname && this.state.refereelastname.length > 0 && String(this.state.refereelastname) !== String(undefined)
               ? this.state.refereelastname
               : values.refereelastname,
         );
         data.append(
            'refereeemail',
            this.state.refereeemail && this.state.refereeemail.length > 0 && String(this.state.refereeemail) !== String(undefined)
               ? this.state.refereeemail
               : values.refereeemail,
         );
         data.append('refereephone[number]', this.state.refereephone.number);
         data.append('refereephone[code]', this.state.refereephone.code);
         data.append('refereephone[dialcountry]', this.state.refereephone.dialcountry);
         data.append('refereejobtitle', values.refereejobtitle);
         data.append('refereecompany', values.refereecompany);
         data.append('refereecapacity', values.refereecapacity);
         data.append('refereehowtoknown', values.refereehowtoknown);
         data.append(
            'applicantfirstname',
            this.state.applicantfirstname && this.state.applicantfirstname.length > 0 && String(this.state.applicantfirstname) !== String(undefined)
               ? this.state.applicantfirstname
               : values.applicantfirstname,
         );
         data.append(
            'applicantlastname',
            this.state.applicantlastname && this.state.applicantlastname.length > 0 && String(this.state.applicantlastname) !== String(undefined)
               ? this.state.applicantlastname
               : values.applicantlastname,
         );
         data.append('applicantemail', values.applicantemail);
         data.append('applicantphone[number]', this.state.applicantphone.number);
         data.append('applicantphone[code]', this.state.applicantphone.code);
         data.append('applicantphone[dialcountry]', this.state.applicantphone.dialcountry);
         data.append('applicantjobtitle', values.applicantjobtitle);
         data.append('applicantcompany', values.applicantcompany);
         data.append('employedfrom', this.state.employedfrom);
         data.append('employedto', this.state.employedto);
         data.append('remployee', this.state.remployee);
         data.append('remployeenotes', values.remployeenotes || '');
         data.append('followcareplans', values.followcareplans);
         data.append('reliability', values.reliability);
         data.append('character', values.character);
         data.append('dignity', values.dignity);
         data.append('attitude', values.attitude);
         data.append('communication', values.communication);
         data.append('relationships', values.relationships);
         data.append('workunderinitiative', values.workunderinitiative);
         data.append('disciplinaryaction', this.state.disciplinaryaction);
         data.append('disciplinaryactiondetails', values.disciplinaryactiondetails || '');
         data.append('investigations', this.state.investigations);
         data.append('investigationsdetails', values.investigationsdetails || '');
         data.append('vulnerablepeople', this.state.vulnerablepeople);
         data.append('vulnerablepeopledetails', values.vulnerablepeopledetails || '');
         data.append('criminaloffence', this.state.criminaloffence);
         data.append('criminaloffencedetails', values.criminaloffencedetails || '');
         data.append('additionalcomments', values.additionalcomments);
         data.append('confirm', values.confirm);
         data.append('agree', values.agree);
         data.append('campanystamp', this.state.campanystamp);
         data.append('referencefor', this.props.match.params.referencefor);
         data.append('username', this.props.match.params.username);
         data.append('port', window.location.port);
         data.append('hostname', window.location.hostname);
         data.append('protocol', window.location.protocol);
         data.append('characterRef', this.state.characterRef);
         request({
            url: '/site/employee/reference/save',
            method: 'POST',
            data: data,
         }).then((res) => {
            if (res.status === 1) {
               this.componentDidMount();
               toast.update(toastId, {
                  render: res.response,
                  type: toast.TYPE.SUCCESS,
                  autoClose: 2500,
               });
               this.props.history.push('/reference/form/success');
            } else if (res.status === 0) {
               toast.update(toastId, {
                  render: res.response,
                  type: toast.TYPE.ERROR,
                  autoClose: 2500,
               });
            }
         });
         // } else {
         //   toast.error("Stamp Required");
         // }
      } else {
         toast.error('Please fill all required fields');
      }
   };

   clear = () => {
      this.sigPad.clear();
   };

   trim = () => {
      if (this.sigPad.isEmpty() === false) {
         let image = this.sigPad.getTrimmedCanvas().toDataURL('image/png');
         fetch(image)
            .then((res) => res.blob())
            .then((blob) => {
               const file = new File([blob], 'png', { type: 'image/png' });
               const data = new FormData();
               data.append('signature', file);
               request({
                  url: '/site/reference/signature/upload',
                  method: 'post',
                  data,
               })
                  .then((res) => {
                     if (res && +res.status === 1) {
                        this.setState({
                           showModal: !this.state.showModal,
                           signature: res.response,
                        });
                     } else {
                        toast.info(res.response);
                     }
                  })
                  .catch((err) => {
                     toast.error('Something Went wrong');
                     console.log('err', err);
                  });
            });
      } else {
         toast.error('Signature is required field.');
      }
   };

   imageError = () => {
      this.setState({ logourl: '' });
   };

   handler = (status, value, countryData, number, id) => {
      if (status === true) {
         this.setState({
            phoneerror: false,
         });
      } else {
         this.setState({
            phoneerror: true,
         });
      }
      this.setState({
         refereephone: {
            number: value,
            code: countryData.dialCode,
            dialcountry: countryData.iso2,
         },
      });
   };
   handler1 = (status, value, countryData, number, id) => {
      if (status === true) {
         this.setState({
            phoneerror1: false,
         });
      } else {
         this.setState({
            phoneerror1: true,
         });
      }
      this.setState({
         applicantphone: {
            number: value,
            code: countryData.dialCode,
            dialcountry: countryData.iso2,
         },
      });
   };
   render() {
      let { logourl, logo_loder } = this.state;
      return (
         <div className="candidate-main referenceform">
            <div className="mar-top"></div>
            <Fragment>
               <ToastContainer position="top-right" autoClose={2500} closeOnClick />
               {
                  <div className="card main-space ins-stru">
                     <div className="container">
                        <div className="reference-main">
                           <div className="row ">
                              <Row className="referance_header">
                                 <Col xs="12" md="6" className="">
                                    {logo_loder ? (
                                       <div className="home-loader">
                                          <i className="fa fa-spinner fa-spin fa-5x" />{' '}
                                       </div>
                                    ) : logourl && String(logourl).includes('uploads') ? (
                                       <span className="left_profle ">
                                          <img
                                             src={logourl && logourl.length > 0 && String(logourl) !== String(undefined) ? `${NodeURL}/${logourl}` : logo}
                                             onError={(e) => this.imageError(e)}
                                             alt="logo" width={180} 
                                          />
                                       </span>
                                    ) : null}
                                    <div className="candit_profile mt-5">
                                       <img alt="Candidate" src={`${NodeURL}/${this.state.avatar}`} />
                                    </div>
                                    <h3 className="title mt-3">
                                       Employee Reference Request for <span> {`${this.state.name || ""} ${this.state.surname || ""}`}</span>
                                    </h3>
                                    <h6 className=" mt-5">Please complete the reference form and submit</h6>
                                 </Col>
                                 <Col xs="12" md="6" className="rht_image">
                                    <img src={titleImage} alt="titleImage" />
                                 </Col>
                              </Row>
                              <div className="col-sm-12 col-xs-12 padd-zero ref_form">
                                 <AvForm ref={(clear) => (this.form = clear)} onSubmit={this.OnFormSubmit}>
                                    <div className="section-divder mt-4">
                                       <h5 className="card-title mb-2">1. Reference Details</h5>
                                       <div className="">
                                          <div className="row">
                                             <Col xs="12" md="6" className="position-relative">
                                                <AvField
                                                   type="text"
                                                   name="refereefirstname"
                                                   label="First name"
                                                   required
                                                   value={this.state.refereefirstname}
                                                   onChange={this.onChange}
                                                />
                                             </Col>
                                             <Col xs="12" md="6" className="position-relative">
                                                <AvField
                                                   type="text"
                                                   name="refereelastname"
                                                   label="Last name"
                                                   value={this.state.refereelastname}
                                                   required
                                                   onChange={this.onChange}
                                                />
                                             </Col>
                                             <Col xs="12" md="6" className="position-relative phone-box">
                                                <Label className={this.state.phoneerror ? 'error-color' : null}>Phone</Label>
                                                <IntlTelInput
                                                   placeholder=""
                                                   style={{ width: '100%' }}
                                                   defaultCountry={this.state.refereephone.dialcountry}
                                                   utilsScript={libphonenumber}
                                                   css={
                                                      this.state.phoneerror
                                                         ? ['intl-tel-input', 'form-control', 'error-color']
                                                         : ['intl-tel-input', 'form-control']
                                                   }
                                                   onPhoneNumberChange={this.handler}
                                                   value={this.state.refereephone.number}
                                                   required
                                                />
                                                {this.state.phoneerror ? <div className={'error-color'}>Enter Valid Phone Number!</div> : null}
                                             </Col>
                                             <Col xs="12" md="6" className="position-relative">
                                                <AvField
                                                   type="email"
                                                   name="refereeemail"
                                                   label="Email"
                                                   required
                                                   value={this.state.refereeemail}
                                                   onChange={this.onChange}
                                                />
                                             </Col>
                                             <Col xs="12" md="6" className="position-relative">
                                                <AvField type="text" name="refereejobtitle" label="Job Title" required />
                                             </Col>
                                             <Col xs="12" md="6" className="position-relative">
                                                <AvField type="text" name="refereecompany" label="Company" required />
                                             </Col>
                                             <Col xs="12" md="12">
                                                <AvField
                                                   type="textarea"
                                                   name="refereecapacity"
                                                   label="In what capacity did you know the applicant?"
                                                   required
                                                />
                                             </Col>
                                             <Col xs="12" md="12">
                                                <AvField
                                                   type="textarea"
                                                   name="refereehowtoknown"
                                                   label="How long have you known the applicant?"
                                                   required
                                                />
                                             </Col>
                                          </div>
                                       </div>
                                    </div>

                                    <div className="section-divder">
                                       <div className="">
                                          <h5 className="card-title mb-0">2. Applicant Details</h5>
                                       </div>
                                       <div className="mt-3">
                                          <div className="row">
                                             <Col xs="12" md="6" className="position-relative">
                                                <AvRadioGroup
                                                   inline
                                                   name="charref"
                                                   label="Is it Character Reference ?"
                                                   value={this.state.characterRef}
                                                   className="custom-radio"
                                                >
                                                   <AvRadio label="Yes" value="Yes" onClick={() => this.charRef('Yes')} className="radio-dot" />
                                                   <AvRadio label="No" value="No" onClick={() => this.charRef('No')} className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                          </div>
                                          <div className="row">
                                             <Col xs="12" md="6" className="position-relative">
                                                <AvField
                                                   type="text"
                                                   name="applicantfirstname"
                                                   label="First name"
                                                   value={this.state.applicantfirstname}
                                                   required
                                                   onChange={this.onChange}
                                                />
                                             </Col>
                                             <Col xs="12" md="6" className="position-relative">
                                                <AvField
                                                   type="text"
                                                   name="applicantlastname"
                                                   label="Last name"
                                                   value={this.state.applicantlastname}
                                                   required
                                                   onChange={this.onChange}
                                                />
                                             </Col>
                                             {this.state.characterRef === 'No' ? (
                                                <>
                                                   <Col xs="12" md="6" className="position-relative">
                                                      <AvField type="text" name="applicantjobtitle" label="Job Title" required />
                                                   </Col>
                                                   <Col xs="12" md="6" className="position-relative">
                                                      <AvField
                                                         type="text"
                                                         name="applicantcompany"
                                                         label="Company"
                                                         required={this.state.characterRef === 'No'}
                                                      />
                                                   </Col>
                                                   <Col xs="12" md="6" className="position-relative dates-value">
                                                      <div className={this.state.employedfrom_err ? 'text-danger form-group' : 'form-group'}>
                                                         <label>Date Employed from:</label>
                                                         <Datetime
                                                            className="form-control digits"
                                                            dateFormat="DD-MM-YYYY"
                                                            timeFormat={false}
                                                            closeOnSelect={true}
                                                            required={this.state.characterRef === 'No'}
                                                            value={
                                                               this.state.employedfrom && String(this.state.employedfrom) !== String(undefined)
                                                                  ? moment(this.state.employedfrom).format('DD-MM-YYYY')
                                                                  : ''
                                                            }
                                                            inputProps={{ placeholder: 'Pick Date' }}
                                                            onChange={(e) => {
                                                               if (e._isValid) {
                                                                  this.setState({ employedfrom: e, employedfrom_err: false });
                                                               } else if (!e) {
                                                                  this.setState({ employedfrom: null, employedfrom_err: true });
                                                               } else {
                                                                  this.setState({ employedfrom: null, employedfrom_err: true });
                                                               }
                                                            }}
                                                         />
                                                         {this.state.employedfrom_err ? (
                                                            <span style={{ width: '100%', marginTop: '0.25rem', fontSize: '80', color: '#dc3545 !important' }}>
                                                               {' '}
                                                               This field is invalid{' '}
                                                            </span>
                                                         ) : null}
                                                      </div>
                                                   </Col>
                                                   <Col xs="12" md="6" className="position-relative dates-value">
                                                      <div className={this.state.employedto_err ? 'text-danger form-group' : 'form-group'}>
                                                         <label>Date Employed to ( If current, select today's date ):</label>
                                                         <Datetime
                                                            className="form-control digits"
                                                            dateFormat="DD-MM-YYYY"
                                                            timeFormat={false}
                                                            closeOnSelect={true}
                                                            required={this.state.characterRef === 'No'}
                                                            value={
                                                               this.state.employedto && String(this.state.employedto) !== String(undefined)
                                                                  ? moment(this.state.employedto).format('DD-MM-YYYY')
                                                                  : ''
                                                            }
                                                            inputProps={{ placeholder: 'Pick Date' }}
                                                            onChange={(e) => {
                                                               if (e._isValid) {
                                                                  this.setState({ employedto: e, employedto_err: false });
                                                               } else if (!e) {
                                                                  this.setState({ employedto: null, employedto_err: true });
                                                               } else {
                                                                  this.setState({ employedto: null, employedto_err: true });
                                                               }
                                                            }}
                                                         />
                                                         {this.state.employedto_err ? (
                                                            <span style={{ width: '100%', marginTop: '0.25rem', fontSize: '80', color: '#dc3545 !important' }}>
                                                               {' '}
                                                               This field is invalid{' '}
                                                            </span>
                                                         ) : null}
                                                      </div>
                                                   </Col>
                                                   <Col xs="12" md="6" className="position-relative">
                                                      <AvRadioGroup
                                                         inline
                                                         name="remployee"
                                                         label="Would you re-employ this person?"
                                                         value={this.state.remployee}
                                                         required={this.state.characterRef === 'No'}
                                                      >
                                                         <AvRadio label="Yes" value="yes" onClick={this.remployeeyes} className="radio-dot" />
                                                         <AvRadio label="No" value="no" onClick={() => this.remployeeyes('no')} className="radio-dot" />
                                                      </AvRadioGroup>
                                                   </Col>
                                                </>
                                             ) : (
                                                <></>
                                             )}
                                          </div>
                                       </div>
                                    </div>

                                    <div className="section-divder">
                                       <div className="">
                                          <h5 className="card-title mb-0">
                                             3. SECTION 1 - How would you assess the following?
                                             <small className="card-title-sub">Please tick the relevant boxes Excellent, Good, Average, Poor</small>
                                          </h5>
                                       </div>
                                       <div className="">
                                          <div className="row">
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup inline name="reliability" label="Reliability, timekeeping,attendance" required>
                                                   <AvRadio label="Excellent" value="excellent" className="radio-dot" />
                                                   <AvRadio label="Good" value="good" className="radio-dot" />
                                                   <AvRadio label="Average" value="average" className="radio-dot" />
                                                   <AvRadio label="Poor" value="poor" className="radio-dot" />
                                                   <AvRadio label="Not Applicable" value="Not Applicable" className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup inline name="character" label="Character" required>
                                                   <AvRadio label="Excellent" value="excellent" className="radio-dot" />
                                                   <AvRadio label="Good" value="good" className="radio-dot" />
                                                   <AvRadio label="Average" value="average" className="radio-dot" />
                                                   <AvRadio label="Poor" value="poor" className="radio-dot" />
                                                   <AvRadio label="Not Applicable" value="Not Applicable" className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup inline name="attitude" label="Attitude" required>
                                                   <AvRadio label="Excellent" value="excellent" className="radio-dot" />
                                                   <AvRadio label="Good" value="good" className="radio-dot" />
                                                   <AvRadio label="Average" value="average" className="radio-dot" />
                                                   <AvRadio label="Poor" value="poor" className="radio-dot" />
                                                   <AvRadio label="Not Applicable" value="Not Applicable" className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup inline name="dignity" label="Ability to ensure dignity is upheld" required>
                                                   <AvRadio label="Excellent" value="excellent" className="radio-dot" />
                                                   <AvRadio label="Good" value="good" className="radio-dot" />
                                                   <AvRadio label="Average" value="average" className="radio-dot" />
                                                   <AvRadio label="Poor" value="poor" className="radio-dot" />
                                                   <AvRadio label="Not Applicable" value="Not Applicable" className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup inline name="communication" label="Communication" required>
                                                   <AvRadio label="Excellent" value="excellent" className="radio-dot" />
                                                   <AvRadio label="Good" value="good" className="radio-dot" />
                                                   <AvRadio label="Average" value="average" className="radio-dot" />
                                                   <AvRadio label="Poor" value="poor" className="radio-dot" />
                                                   <AvRadio label="Not Applicable" value="Not Applicable" className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup inline name="relationships" label="Relationships with colleagues" required>
                                                   <AvRadio label="Excellent" value="excellent" className="radio-dot" />
                                                   <AvRadio label="Good" value="good" className="radio-dot" />
                                                   <AvRadio label="Average" value="average" className="radio-dot" />
                                                   <AvRadio label="Poor" value="poor" className="radio-dot" />
                                                   <AvRadio label="Not Applicable" value="Not Applicable" className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup inline name="workunderinitiative" label="Ability to work under own initiative" required>
                                                   <AvRadio label="Excellent" value="excellent" className="radio-dot" />
                                                   <AvRadio label="Good" value="good" className="radio-dot" />
                                                   <AvRadio label="Average" value="average" className="radio-dot" />
                                                   <AvRadio label="Poor" value="poor" className="radio-dot" />
                                                   <AvRadio label="Not Applicable" value="Not Applicable" className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup inline name="followcareplans" label="Ability to follow care plans" required>
                                                   <AvRadio label="Excellent" value="excellent" className="radio-dot" />
                                                   <AvRadio label="Good" value="good" className="radio-dot" />
                                                   <AvRadio label="Average" value="average" className="radio-dot" />
                                                   <AvRadio label="Poor" value="poor" className="radio-dot" />
                                                   <AvRadio label="Not Applicable" value="Not Applicable" className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                          </div>
                                       </div>
                                       <div className="">
                                          <h5 className="card-title mb-0">
                                             4. SECTION 2 - Please answer the following questions
                                             <small className="card-title-sub">Please tick the relevant boxes Excellent, Good, Average, Poor</small>
                                          </h5>
                                       </div>
                                       <div className="">
                                          <div className="row">
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup
                                                   inline
                                                   name="disciplinaryaction"
                                                   label="Has the applicant been subject to any disciplinary action?"
                                                   required
                                                >
                                                   <AvRadio label="Yes" value="yes" onClick={() => this.disciplinaryactionyes('yes')} className="radio-dot" />
                                                   <AvRadio label="No" value="no" onClick={this.disciplinaryactionyes} className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             {this.state.disciplinaryactionyes ? (
                                                <Col xs="12" md="12" className="position-relative">
                                                   <AvField
                                                      type="textarea"
                                                      label="Please provide details:"
                                                      name="disciplinaryactiondetails"
                                                      value={this.state.disciplinaryactiondetails || ''}
                                                      placeholder=""
                                                   />
                                                </Col>
                                             ) : null}
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup
                                                   inline
                                                   name="investigations"
                                                   label="Are you aware of the applicants involvement in any safeguarding investigations previous or current ."
                                                   required
                                                >
                                                   <AvRadio label="Yes" value="yes" onClick={() => this.investigationsyes('yes')} className="radio-dot" />
                                                   <AvRadio label="No" value="no" onClick={this.investigationsyes} className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             {this.state.investigationsyes ? (
                                                <Col xs="12" md="12" className="position-relative">
                                                   <AvField
                                                      type="textarea"
                                                      label="Please provide details:"
                                                      name="investigationsdetails"
                                                      value={this.state.investigationsdetails || ''}
                                                      placeholder=""
                                                   />
                                                </Col>
                                             ) : null}
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup
                                                   inline
                                                   name="vulnerablepeople"
                                                   label="Are you aware of any reasons why the applicant should not be employed to work with children or vulnerable people?"
                                                   required
                                                >
                                                   <AvRadio label="Yes" value="yes" onClick={() => this.vulnerablepeopleyes('yes')} className="radio-dot" />
                                                   <AvRadio label="No" value="no" onClick={this.vulnerablepeopleyes} className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             {this.state.vulnerablepeopleyes ? (
                                                <Col xs="12" md="12" className="position-relative">
                                                   <AvField
                                                      type="textarea"
                                                      label="Please provide details:"
                                                      name="vulnerablepeopledetails"
                                                      value={this.state.vulnerablepeopledetails || ''}
                                                      placeholder=""
                                                   />
                                                </Col>
                                             ) : null}
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvRadioGroup
                                                   inline
                                                   name="criminaloffence"
                                                   label="To the best of your knowledge, has the applicant been convicted or cautioned of a criminal offence?"
                                                   required
                                                >
                                                   <AvRadio label="Yes" value="yes" onClick={() => this.criminaloffenceyes('yes')} className="radio-dot" />
                                                   <AvRadio label="No" value="no" onClick={this.criminaloffenceyes} className="radio-dot" />
                                                </AvRadioGroup>
                                             </Col>
                                             {this.state.criminaloffenceyes ? (
                                                <Col xs="12" md="12" className="position-relative">
                                                   <AvField
                                                      type="textarea"
                                                      label="Please provide details:"
                                                      name="criminaloffencedetails"
                                                      value={this.state.criminaloffencedetails || ''}
                                                      placeholder=""
                                                   />
                                                </Col>
                                             ) : null}
                                             <Col xs="12" md="12" className="position-relative">
                                                <AvField type="textarea" label="Additional Comments" name="additionalcomments" placeholder="" />
                                             </Col>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="">
                                       <div className="">
                                          <h5 className="card-title mb-0">5. Please Confirm:</h5>
                                          <label className="checkbox-btn ref-plc">
                                             <AvGroup>
                                                <div className='confirm_form'>
                                                <Label check for="confirm" />
                                                <AvInput className=" checkbox-btn__checkbox" type="checkbox" name="confirm" required />
                                                   <span className="checkbox-btn__checkbox-custom mt-3">
                                                      <i className="mdi mdi-check" />
                                                   </span>
                                                   <span className="checkbox-btn__label">
                                                      I can confirm that all the details provided are accurate at the time that this reference was completed. I
                                                      can confirm that I am authorised to provide a reference on behalf of my organisation. I understand this
                                                      reference may be shown to a third party for auditing purposes and I can confirm that{' '}
                                                      {this.state.company_name} has this organisation's consent and authorisation to disclose the contents of
                                                      this reference to its end user, hirer clients. I understand that the applicant has the legal right to
                                                      request a copy of their reference.
                                                   </span>
                                                </div>
                                                <AvFeedback>This is required!</AvFeedback>
                                             </AvGroup>
                                          </label>
                                       </div>
                                    </div>
                                    <div className="">
                                       {/* <label className="checkbox-btn ref-plc">
                                          <AvGroup>
                                             <Label check for="confirm" />
                                             <AvInput className=" checkbox-btn__checkbox" type="checkbox" name="confirm" required />
                                             <span className="checkbox-btn__checkbox-custom mt-3">
                                                <i className="mdi mdi-check" />
                                             </span>
                                             <span className="checkbox-btn__label">Check to confirm</span>
                                             <AvFeedback>This is required!</AvFeedback>
                                          </AvGroup>
                                       </label> */}
                                       <div className="card-footer">
                                          <div className="row">
                                             <Col xs="12" md="12" className="position-relative">
                                                <button
                                                   className="btn btn-primary newBtn"
                                                   onClick={(e) => {
                                                      this.openModal(e);
                                                   }}
                                                >
                                                   Add Signature
                                                </button>{' '}
                                                <br />
                                                <br />
                                                {this.state.signature && this.state.signature.length > 0 ? (
                                                   <Col xs="6" md="12">
                                                      <img width="200px" height="200px" src={`${NodeURL}/${this.state.signature}`} alt="Signature" />
                                                   </Col>
                                                ) : null}
                                             </Col>
                                          </div>
                                       </div>
                                       <Col xs="12" md="12" className="position-relative offical-box">
                                          <Label for="exampleCustomFileBrowser" className="offical-box-text">
                                             Official company stamp.
                                          </Label>
                                          <CustomInput
                                             type="file"
                                             id="exampleCustomFileBrowser"
                                             name="campanystamp"
                                             onChange={this.fileChangedHandler}
                                             label={this.state.campanystampName ? this.state.campanystampName : 'Upload  Image'}
                                             encType="multipart/form-data"
                                             accept=".png, .jpg, .jpeg"
                                          />
                                       </Col>
                                       <div className="mid-values">
                                          <p>
                                             If you are not using an official company email please upload a picture of your company stamp / business
                                             card/letterhead/compliment slip.
                                          </p>
                                       </div>
                                       <label className="checkbox-btn">
                                          <AvGroup>
                                             <Label check for="agree" />
                                             <AvInput className="checkbox-btn__checkbox" type="checkbox" name="agree" required />

                                             <span className="checkbox-btn__checkbox-custom mt-3">
                                                <i className="mdi mdi-check" />
                                             </span>
                                             <span className="checkbox-btn__label userAggrement">
                                                By using this form you agree with the storage and handling of your data by this website as defined in our
                                                Privacy Policy.
                                             </span>
                                             <AvFeedback>This is required!</AvFeedback>
                                          </AvGroup>
                                       </label>
                                    </div>
                                    <div className="card-footer text-right">
                                       <button type="submit" title="Click here to add reference" className="btn btn-primary newBtn">
                                          {' '}
                                          Submit Form{' '}
                                       </button>
                                    </div>
                                    <Modal isOpen={this.state.showModal} toggle={this.toggleModal} className="requs-pops" centered={true}>
                                       <ModalBody>
                                          <div className="popup adding_folder">
                                             <div className="modal-dialog">
                                                <div className="modal-content">
                                                   <div className="modal-header">
                                                      <h4 className="modal-title" id="myModalLabel">
                                                         Signature Pad
                                                      </h4>
                                                   </div>
                                                   <div className="modal-body">
                                                      <div className="sig-container">
                                                         <div className="sigContainer">
                                                            <SignaturePad
                                                               canvasProps={{
                                                                  width: 500,
                                                                  height: 200,
                                                                  className: 'sigPad',
                                                               }}
                                                               ref={(ref) => {
                                                                  this.sigPad = ref;
                                                               }}
                                                            />
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </ModalBody>
                                       <ModalFooter className="footer-model">
                                          <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.clear}>
                                             Clear{' '}
                                          </button>
                                          <Button className="btn btn-secondary" onClick={this.toggleModal}>
                                             Cancel{' '}
                                          </Button>
                                          <button type="button" className="btn btn-primary" onClick={this.trim}>
                                             Save
                                          </button>
                                       </ModalFooter>
                                    </Modal>
                                 </AvForm>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               }
            </Fragment>
         </div>
      );
   }
}
export default Registration;
